import classNames from "classnames";
import { ReactNode } from "react";
import { PageHeader } from "../typography/pageHeader";

export const AdminPageHeader = ({
  title,
  eyebrow,
  subtitle,
  description,
  actions,
  meta,
  className = "",
}: {
  title: ReactNode;
  eyebrow?: string;
  subtitle?: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  meta?: ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={classNames(
        "flex flex-col gap-4 md:flex-row md:items-end md:justify-between",
        className,
      )}
    >
      <div className="min-w-0">
        {eyebrow && (
          <p className="mb-2 text-xs font-bold uppercase tracking-[0.08em] text-grey-500">
            {eyebrow}
          </p>
        )}
        <PageHeader
          header={title}
          className="!font-dela font-normal leading-tight"
        />
        {subtitle && (
          <p className="mt-2 text-xs font-bold uppercase tracking-[0.08em] text-grey-500">
            {subtitle}
          </p>
        )}
        {description && (
          <p className="mt-2 max-w-[680px] text-sm leading-6 text-grey-600 md:text-base">
            {description}
          </p>
        )}
      </div>

      {(actions || meta) && (
        <div className="flex flex-col items-start gap-3 md:items-end">
          {meta}
          {actions}
        </div>
      )}
    </div>
  );
};
